import { useGenUiConfig } from '../../shared/ui/config.js';
import type { BusRecentSearch } from '@voll-intelligence/domain';

/**
 * As rodoviárias para um termo (a busca de rodoviária da bancada, no web-chat
 * `GET /bus/places`) — leitura idempotente, chamada a cada tecla do campo.
 * `recentSearches` (opcional, `GET /bus/searches/recent`) alimenta as paradas
 * recentes do campo aberto vazio; ausente ou falhando, o campo pede o termo.
 */
export interface BusStopsPort {
  searchStops: (term: string) => Promise<readonly { code: string; name: string }[]>;
  recentSearches?: () => Promise<readonly BusRecentSearch[]>;
}

export function useBusStopsPort(): BusStopsPort | null {
  return useGenUiConfig().ports?.busStops ?? null;
}
